module.exports = __webpack_public_path__ + "img/ic_display_grid.89a57f08.svg";